import { render, staticRenderFns } from "./FormSingleLang.vue?vue&type=template&id=22c3e3aa"
import script from "./FormSingleLang.vue?vue&type=script&lang=js"
export * from "./FormSingleLang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports